<template>
  <div class="organizations">
    <!-- Hero section -->
    <section class="organizations__hero">
      <v-container>
        <h1 class="organizations__hero-title">
          Conoce a las organizaciones que buscan talentos con sentido
        </h1>
      </v-container>
    </section>

    <!-- Search box -->
    <section class="organizations__search">
      <v-container class="py-0 pt-2">
        <v-text-field
          class="organizations__search-input"
          label="Buscar"
          v-model="searchText"
          prepend-inner-icon="mdi-magnify"
          clearable
          solo
          @input="searchKeyInput()"
          @keyup.enter.native="searchOrganizations({tags: searchTags})"
          @click:clear="onSearchClear"
        />
      </v-container>
    </section>

    <section class="organizations__list">
      <v-container>
        <!-- Loader -->
        <v-row v-if="loading">
          <v-col v-for="n in 16" :key="n" cols="12" sm="4" md="3">
            <v-skeleton-loader
              class=""
              type="card"
              min-height="300"
              elevation="1"
            />
          </v-col>
        </v-row>

        <v-row v-else-if="organizations && organizations.length > 0" justify="center">
          <!-- List -->
          <OrganizationsList
            :organizations="organizations"
            @page-change="changePage"
          />
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import OrganizationsList from "@/components/OrganizationsList";
import { meta } from "@/libs/mixins";

export default {
    name: "Organizations",

    components: { OrganizationsList },
    
    mixins: [meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Organizaciones",
        });
    },

    data() {
        return {
            loading: false,
            searchText: "",
            timerId: null,
        };
    },

    computed: {
        ...mapGetters("organizations", ["organizations"]),

        searchTags() {
            return this.searchText.trim().split(" ");
        },
    },

    methods: {
        ...mapActions("organizations", ["getOrganizations", "searchOrganizations"]),

        async changePage(page) {
            this.loading = true;
            try {
                if (this.searchText) {
                    await this.searchOrganizations({
                        tags: this.searchTags,
                        page,
                    });
                } else if (this.searchText == "") {
                    await this.loadOrganizations(page);
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        async loadOrganizations(page) {
            this.loading = true;
            try {
                await this.getOrganizations({
                    page
                });
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        onSearchClear() {
            this.loadOrganizations();
        },
        searchKeyInput() {
            if (this.timerId) clearTimeout(this.timerId);
            this.timerId = setTimeout(() => {
                if (this.searchText === "") {
                    this.loadOrganizations(1);
                } else {
                    this.searchOrganizations({ tags: this.searchTags });
                }
            }, process.env.VUE_APP_SEARCH_TIMEOUT);
        },
    },

    mounted() {
        this.loadOrganizations(1);
    },
};
</script>
